import { useMutation } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { memo, useEffect, useRef } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useChatConfig } from '@/contexts/ChatConfigProvider';
import { useUser } from '@/hooks/useUser';
import { aiCoreApi } from '@/services/aiCoreClient';
import { useBoundStore } from '@/store/store';

export const Welcome = memo(function Welcome() {
  const { chatId } = useChatConfig();
  const { login } = useUser();
  const { pushRoute } = useBoundStore(
    useShallow(state => ({
      pushRoute: state.pushRoute,
    })),
  );

  // Use useRef to track if verification was already attempted
  const loginAttempted = useRef(false);

  /**
   * Authenticate users against API, this will create a new user
   * in the database if it does not exist. Otherwise, it will return
   * the existing user.
   */
  const { mutateAsync: authenticate } = useMutation({
    // TODO handle error
    mutationFn: async () => {
      const data = await aiCoreApi.auth.local({
        chatId,
      });

      login(data.user, data.token);

      pushRoute('chat');
    },
  });

  // Quickly authenticate user autonomously
  useEffect(() => {
    if (!loginAttempted.current) {
      loginAttempted.current = true;
      authenticate();
    }
  }, [authenticate]);

  return (
    <div className='relative flex size-full items-center justify-center'>
      <Loader2 className='size-10 animate-spin' />
    </div>
  );
});
